export const categories = [
  'laptops',
  'smartphones',
  'tablets',
  'monitors',
  'headphones',
  'loudspeakers',
  'smartwatches',
  'accessories',
];
